<script setup lang="ts">
import { formatDate, days } from "@/utils/date";
import { CircleLoader } from "lorga-ui";

interface IPlan {
  auftraege: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [datum: string]: any[];
  };
  wochen: {
    [datum: string]: number;
  };
}

defineProps<{
  plan: IPlan | undefined;
  mini?: boolean;
}>();
</script>

<template>
  <div v-if="!plan">
    <CircleLoader class="text-white" />
  </div>
  <div
    v-else
    class="flex w-auto pb-2 space-x-5 overflow-x-auto print:space-x-0 custom-scrollbar print:inline-block print:overflow-x-visible"
  >
    <div
      v-for="datum in Object.keys(plan.auftraege)"
      :key="datum"
      class="relative shrink-0"
      :class="{
        'w-96': !mini,
      }"
    >
      <div
        class="bg-gray-400 print:mb-10 print:border print:bg-white print:border-black"
      >
        <div
          class="sticky top-0 z-10 px-4 py-1 mb-0 text-lg font-medium bg-gray-200 shadow-lg print:bg-white print:shadow-none print:border-b print:border-black print:relative print:mb-0"
        >
          <div class="flex justify-between">
            <div>
              {{ days[new Date(datum).getDay()] }} ({{ formatDate(datum) }})
            </div>
            <div class="print:hidden">
              <slot name="top" :datum="datum" />
            </div>
          </div>
        </div>
        <div class="pl-2 pr-1 print:p-0">
          <div
            class="flex flex-col py-2 h-auto pr-1 space-y-3 max-h-[calc(100vh-232px)] overflow-y-auto custom-scrollbar vertical print:overflow-y-visible print:p-0 print:max-h-none print:space-y-0 print:divide-y print:divide-black"
          >
            <template
              v-for="auftrag in plan.auftraege[datum]"
              :key="auftrag.id"
            >
              <slot name="auftrag" :auftrag="auftrag" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
